import React from 'react';
import moment from 'moment';
import { useModal } from '../hooks'

import TableHeader from './TableHeader';
import Modal from './Modal';
import {CSRF_TOKEN, requestCallback} from '../lib/helpers';
import axios from 'axios';
import {get} from 'lodash';
import DotTooltip from "./DotTooltip";

const UserRedemptionsList = ({
  userRedemptions = [],
}) => {
  const [
  ] = useModal({
    keyboardBindings: true,
  })

  const [
    updateModal,
    updateModalSet,
    $submitButton,
  ] = useModal({
    defaultValue: {
      isActive: false,
      userRedemptionId: null
    },
    keyboardBindings: true,
  })

  function updateUserRedemption(id, status) {
    requestCallback(axios.put(`/${gon.currentProvider}/api/user_redemptions/${id}`, {
      status: status,
      authenticity_token: CSRF_TOKEN
    }))
  }

  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>User Redemptions list</h2>
        </div>
        <div className='MainHeader__right'>

        </div>
      </div>

      <div className='Table Table--user-redemptions-list'>
        {(() => {
          const columnHeaders = [
            {
              label: 'Request ID'
            },
            {
              label: 'User ID'
            },
            {
              label: 'Email'
            },
            {
              label: 'Redemption ID'
            },
            {
              label: 'Redemption Name'
            },
            {
              label: 'Amount'
            },
            {
              label: 'Claim Code'
            },
            {
              label: 'Status'
            },
            {
              label: 'Created At'
            },
            {
              label: 'Updated At'
            },
            {
              label: 'Manage',
            }
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}

        {userRedemptions.map((userRedemption) => (
          <div
            className='Table__row'
            key={userRedemption.id}
            data-x={userRedemption}
          >
            <div className='Table__col'>{userRedemption.id}</div>
            <div className='Table__col'>
              <DotTooltip
                user={userRedemption.user}
              />
            </div>
            <div className='Table__col'>{userRedemption.email}</div>
            <div className='Table__col'>{userRedemption.redemptionId}</div>
            <div className='Table__col'>{userRedemption.redemptionName}</div>
            <div className='Table__col'>{userRedemption.currencyCode}{userRedemption.redemptionAmount}</div>
            <div className='Table__col'>
              {
                userRedemption.claimCode == null ?
                  ''
                :
                  userRedemption.claimCode.replace(/.(?=.{5})/g, '*')
              }
            </div>
            <div className='Table__col'>{userRedemption.status}</div>

            <div
              className='Table__col'
              dangerouslySetInnerHTML={
                {
                  __html: userRedemption.createdAt !== null ?
                    moment(userRedemption.createdAt).format('YYYY-MM-DD<br />HH:mm')
                  :
                    'N/A'
                }
              }
            />

            <div
              className='Table__col'
              dangerouslySetInnerHTML={
                {
                  __html: userRedemption.updatedAt !== null ?
                    moment(userRedemption.updatedAt).format('YYYY-MM-DD<br />HH:mm')
                    :
                    'N/A'
                }
              }
            />

            <div className='Table__col'>
              <div className='Table__controls'>
                <a
                  className='Table__controls__a Table__controls__a--pencil'
                  onClick={() => {
                    updateModalSet({
                      isActive: true,
                      userRedemptionId: userRedemption.id,
                      status: userRedemption.status
                    })
                  }}
                >
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>

      <Modal
        isActive={updateModal.isActive}
        onToggleModal={() => {
          updateModalSet((prevState) => ({
            ...prevState,
            isActive: false
          }))
        }}
      >
        <div className='UserRedemptionModal'>
          <h3 className='Modal__h3'>Update redemption status</h3>
          <label className='User__form__label'>Redemption status</label>
          <select
              className='Select'
              name='status'
              value={get(updateModal, 'status')}
              onChange={(e) => {
                const $el = e.target

                updateModalSet({
                  ...updateModal,
                  status: $el.value,
                })
              }}
            >
              <option value={'pending'}>Pending</option>
              <option value={'success'}>Success</option>
            </select>



          <div className='Modal__footer Modal__footer--without-border'>
            <a
              className='Button Button--gray-light'
              onClick={() => {
                updateModalSet((prevState) => ({
                  ...prevState,
                  isActive: false
                }))
              }}
            >
              Cancel
            </a>

            <button
              className='Button Button--blue'
              onClick={(e) => {
                const $els = e.target.elements

                updateUserRedemption(
                  updateModal.userRedemptionId,
                  updateModal.status)
              }}
              ref={$submitButton}
            >
              Submit
            </button>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
}

export default UserRedemptionsList
